import FreeBets from './FreeBets';
export default FreeBets;